import React, { useEffect, useState } from "react";
import api from "../../api/axios";

const ProductModal = ({ show, onClose, onCreated }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    category: "",
    product_name: "",
    product_link: "",
    is_new: false,
    product_image: null,
    status: true,
  });

  /* ---------------- Fetch categories only when modal opens ---------------- */
  useEffect(() => {
    if (show) {
      api.get("companyblog/admin/categories/")
        .then((res) => setCategories(res.data))
        .catch(() => alert("Failed to load categories"));
    }
  }, [show]);

  /* ---------------- Reset form when modal closes ---------------- */
  useEffect(() => {
    if (!show) {
      setForm({
        category: "",
        product_name: "",
        product_link: "",
        is_new: false,
        product_image: null,
        status: true,
      });
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? files[0]
          : value,
    }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!form.product_image) {
      alert("Product image is required");
      return;
    }

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) =>
      formData.append(key, value)
    );

    try {
      setLoading(true);
      await api.post("companyblog/admin/products/", formData);
      onCreated();   // refresh product list
      onClose();     // close modal
    } catch (err) {
      alert("Failed to create product");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Create Product</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            />
          </div>

          {/* Form */}
          <form onSubmit={submitHandler}>
            <div className="modal-body">

              {/* Row 1 */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Service Category *</label>
                  <select
                    className="form-control"
                    name="category"
                    value={form.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select category</option>
                    {categories.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Product Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="product_name"
                    value={form.product_name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Row 2 */}
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="is_new"
                  checked={form.is_new}
                  onChange={handleChange}
                />
                <label className="form-check-label">
                  Is Product New
                </label>
              </div>

              {/* Row 3 */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="form-label">Primary Image *</label>
                  <input
                    type="file"
                    className="form-control"
                    name="product_image"
                    onChange={handleChange}
                    required
                  />
                  <small className="text-muted">
                    Required dimension: 1680 × 1120 px
                  </small>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Product Link *</label>
                  <input
                    type="url"
                    className="form-control"
                    name="product_link"
                    value={form.product_link}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

            </div>

            {/* Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default ProductModal;
